import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 70px;

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .header button {
    width: auto;
  }
`;
